module.exports = __webpack_public_path__ + "static/media/KN2.2cee9cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/KN/KN2.png
// module id = 664
// module chunks = 0